import { nanoid } from "nanoid"
import { customAlphabet } from "nanoid"
import { Serializable } from "@/core/api/decorators/serializable_decorator"
import { ServiceType } from "../../active/constants/serviceType"
import { EngagementType } from "../../active/constants/engagementType"
import { SupplierNewArgs } from "../args/supplierNewArgs"
import { UserModel } from "@/modules/users/models/userModel"
import { UserManagerModel } from "@/modules/users/models/userManagerModel"
import { ProposalBaseModel } from "../proposalBaseModel"
import { HiringLocation } from "./hiringLocation"
import { SubAreaModel } from "@/modules/prices/models/subAreaModel"
import { SupplierListView } from "../../supplier/models/supplierListView"
import {
  ArrayMinSize,
  IsArray,
  IsEnum,
  IsNotEmpty,
  ValidateNested,
} from "class-validator"
import { CurrenciesDSVType } from "@/modules/prices/constants/currenciesDSV"

const generateId = customAlphabet("0123456789abcdefghijklmnopqrstuvwxyz", 12)

@Serializable
export class RFSContractorModel extends ProposalBaseModel {
  @IsEnum(ServiceType, {
    message: "common:form.errors.empty",
    groups: ["rfs"],
  })
  serviceType: ServiceType.B2BContractor = ServiceType.B2BContractor
  @IsEnum(EngagementType, {
    message: "common:form.errors.empty",
    groups: ["rfs"],
  })
  engagementType: EngagementType = EngagementType.TimeAndMaterial
  projectName: string = ""
  @IsNotEmpty({
    message: "common:form.errors.empty",
    groups: ["rfs"],
  })
  justification: string = ""
  requestId: string = generateId()
  @ValidateNested({
    groups: ["rfs"],
  })
  costCenterId: string = ""
  costCenterName: string = ""
  @IsArray({
    message: "common:form.errors.empty",
    groups: ["rfs"],
  })
  countryCode: string = ""
  countryName: string = ""
  priceValue: number = 0.0
  priceValueCurrency: "EUR" | "" = ""
  localPriceValue: number = 0.0
  localPriceValueCurrency: CurrenciesDSVType | "" = ""
  companyName: string = ""
  companyVATNumber: string = ""
  companyAddress: string = ""

  selectedSubAreas: SubAreaModel[]
  user: UserModel // Contractor details
  requester: UserModel
  @IsArray({
    message: "common:form.errors.empty",
    groups: ["rfs"],
  })
  approvers: UserManagerModel[]
  @IsArray({
    message: "common:form.errors.empty",
    groups: ["rfs"],
  })
  managers: UserManagerModel[]
  hourlyrateApprovers: UserManagerModel[]
  periodApprovers: UserManagerModel[]

  constructor(init?: Partial<RFSContractorModel>) {
    super(init)
    this.selectedSubAreas = init?.selectedSubAreas || []
    this.user = init?.user || new UserModel()
    this.requester = init?.requester || new UserModel()
    this.approvers = init?.approvers || []
    this.hourlyrateApprovers = init?.hourlyrateApprovers || []
    this.periodApprovers = init?.periodApprovers || []
    this.managers = init?.managers || []
    Object.assign(this, init)
  }
}
